import { FC } from 'react';
import { Box, styled } from '@mui/material';
import { extendedProps, FlexProps } from './types';

export const Flex: FC<FlexProps> = styled(Box as FC<FlexProps>, {
	shouldForwardProp: (prop: string) => !extendedProps.includes(prop)
})(
	({
		column = false,
		justifyCenter = false,
		justifyEnd = false,
		alignStart = false,
		width = undefined,
		height = undefined,
	}) => ({
		display: 'flex',
		flexWrap: 'wrap',
		flexDirection: column ? 'column' : 'row',
		justifyContent: justifyCenter ? 'center' : (justifyEnd && 'flex-end') || 'flex-start',
		alignItems: alignStart ? 'flex-start' : 'center',
		...(width ? { width } : {}),
		...(height ? { height } : {})
	})
);
